import type { ShortsFilters } from './filters';

export function normalizeShortsReferenceProperty(
	referenceProperty?: string
): string | undefined {
	const normalized = referenceProperty?.trim();

	if (
		!normalized ||
		normalized.toLowerCase() === 'undefined' ||
		normalized.toLowerCase() === 'null'
	) {
		return undefined;
	}

	return normalized;
}

/**
 * Recommendations anchored to a property are fully resolved by the backend.
 * Do not mix listing filters into that contract: they would recreate the old
 * client-side recommendation rule and could restrict the feed again.
 */
export function buildFeaturedVideosQueryParams(
	params: ShortsFilters = {}
): ShortsFilters {
	const referenceProperty = normalizeShortsReferenceProperty(
		params.referenceProperty
	);

	if (referenceProperty) {
		return {
			page: params.page ?? 1,
			perPage: params.perPage ?? 12,
			referenceProperty,
			...(params.orderBy !== undefined ? { orderBy: params.orderBy } : {}),
			...(params.sortBy !== undefined ? { sortBy: params.sortBy } : {}),
			...(params.onlyUnwatched !== undefined
				? { onlyUnwatched: params.onlyUnwatched }
				: {}),
			...(params.includeImagesEvery !== undefined
				? { includeImagesEvery: params.includeImagesEvery }
				: {})
		};
	}
	const { referenceProperty: _referenceProperty, ...filters } = params;

	return filters;
}
